// @flow
import {
    useJsonForms,
    ctxToEnumControlProps,
    ctxDispatchToControlProps
} from '@jsonforms/react';

import ctxToTranslationKey from './ctxToTranslationKey';

const useEnumProps = props => {
    const ctx = useJsonForms();
    const controlProps = ctxToEnumControlProps(ctx, props);
    const dispatchProps = ctxDispatchToControlProps(ctx.dispatch);
    const translationKey = ctxToTranslationKey(ctx, controlProps.path);

    return {
        ...controlProps,
        ...dispatchProps,
        translationKey
    };
};

export default useEnumProps;
